import type { OpsPropertyFilter } from "@/lib/opsAdminApi"

interface SummaryData {
  properties: { total: number; active: number }
  devices: { seen_24h: number; stale_7d: number; never_seen: number }
  jobs: { last_run_ok: number; failures_24h: number }
  guidebook_sessions?: { logins_24h: number; failed_logins_24h: number } | null
  llm_usage?: { today_usd: number; last_7d_usd: number } | null
}

export function OpsSummaryCards({
  summary,
  activeFilter,
  onFilterChange,
}: {
  summary: SummaryData | null
  activeFilter: OpsPropertyFilter
  onFilterChange: (filter: OpsPropertyFilter) => void
}) {
  const cards = [
    {
      key: "all" as OpsPropertyFilter,
      title: "Properties",
      line1: `${summary?.properties.total ?? 0} total`,
      line2: `${summary?.properties.active ?? 0} active`,
    },
    {
      key: "stale_devices" as OpsPropertyFilter,
      title: "Devices",
      line1: `${summary?.devices.seen_24h ?? 0} seen <24h`,
      line2: `${summary?.devices.stale_7d ?? 0} stale / ${summary?.devices.never_seen ?? 0} never`,
    },
    {
      key: "job_failures" as OpsPropertyFilter,
      title: "Jobs",
      line1: `${summary?.jobs.last_run_ok ?? 0} last run ok`,
      line2: `${summary?.jobs.failures_24h ?? 0} failures 24h`,
    },
    {
      key: "needs_attention" as OpsPropertyFilter,
      title: "Guidebook",
      line1: `${summary?.guidebook_sessions?.logins_24h ?? 0} logins 24h`,
      line2: `${summary?.guidebook_sessions?.failed_logins_24h ?? 0} failed 24h`,
    },
    {
      key: "all" as OpsPropertyFilter,
      title: "LLM Usage",
      line1: `$${(summary?.llm_usage?.today_usd ?? 0).toFixed(2)} today`,
      line2: `$${(summary?.llm_usage?.last_7d_usd ?? 0).toFixed(2)} last 7d`,
    },
  ]

  return (
    <div className="ops-summary-grid">
      {cards.map((card) => (
        <button
          key={card.title}
          type="button"
          className={`ops-summary-card${activeFilter === card.key ? " ops-summary-card--active" : ""}`}
          onClick={() => onFilterChange(card.key)}
        >
          <div className="ops-summary-card__title">{card.title}</div>
          <div className="ops-summary-card__line">{card.line1}</div>
          <div className="ops-summary-card__line ops-summary-card__line--muted">{card.line2}</div>
        </button>
      ))}
    </div>
  )
}
